export default function TrustBar() {
  return (
    <section id="trust-bar" className="bg-gradient-to-r from-gray-900 to-gray-800 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2">
              <i className="ri-star-fill text-[#C9A961] text-2xl"></i>
              <span className="text-3xl font-bold text-white">5.0</span>
            </div>
            <p className="text-sm text-gray-300">Customer Rating</p>
            <p className="text-xs text-gray-400">127+ Reviews</p>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2">
              <i className="ri-time-line text-[#C9A961] text-2xl"></i>
              <span className="text-3xl font-bold text-white">55+</span>
            </div>
            <p className="text-sm text-gray-300">Years of Experience</p>
            <p className="text-xs text-gray-400">Expert Craftsmen</p>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2">
              <i className="ri-map-pin-line text-[#C9A961] text-2xl"></i>
              <span className="text-3xl font-bold text-white">50</span>
            </div>
            <p className="text-sm text-gray-300">States Served</p>
            <p className="text-xs text-gray-400">Nationwide Coverage</p>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2">
              <i className="ri-mail-send-line text-[#C9A961] text-2xl"></i>
              <span className="text-3xl font-bold text-white">Free</span>
            </div>
            <p className="text-sm text-gray-300">Fabric Swatches</p>
            <p className="text-xs text-gray-400">For Repeat Customers</p>
          </div>
        </div>
      </div>
    </section>
  );
}